import React from 'react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { CrmButton, CrmDrawer, CrmErrorState, CrmLoadingState } from '../ui';

function CrmRecordPreview({
  open,
  onClose,
  title = 'Preview',
  loading,
  error,
  onRetry,
  identity,
  actions = [],
  sections = [],
  onViewRecord,
}) {
  return (
    <CrmDrawer
      open={open}
      onClose={onClose}
      title={title}
      size="sm"
      className="crm-record-preview"
      footer={onViewRecord ? (
        <CrmButton variant="primary" endIcon={<OpenInNewIcon />} onClick={onViewRecord}>
          View full record
        </CrmButton>
      ) : null}
    >
      {loading ? <CrmLoadingState message="Loading contact..." minHeight={220} /> : null}
      {!loading && error ? (
        <CrmErrorState title="Couldn't load this contact." message={error} onRetry={onRetry} />
      ) : null}
      {!loading && !error && identity ? (
        <>
          <section className="crm-record-preview__identity">
            <div className="crm-record-preview__avatar" aria-hidden="true">{identity.initials || '?'}</div>
            <div>
              <h3>{identity.name}</h3>
              {identity.subtitle ? <p>{identity.subtitle}</p> : null}
            </div>
          </section>

          {actions.length ? (
            <div className="crm-record-preview__actions" aria-label="Contact actions">
              {actions.map((action) => (
                <CrmButton
                  key={action.label}
                  size="small"
                  startIcon={action.icon}
                  onClick={action.onClick}
                  disabled={action.disabled}
                >
                  {action.label}
                </CrmButton>
              ))}
            </div>
          ) : null}

          {sections.map((section) => (
            <section key={section.title} className="crm-record-preview__section">
              <h4>{section.title}</h4>
              <dl>
                {section.fields.map((field) => (
                  <div key={field.label}>
                    <dt>{field.label}</dt>
                    <dd>{field.value === null || field.value === undefined || field.value === '' ? '—' : field.value}</dd>
                  </div>
                ))}
              </dl>
            </section>
          ))}
        </>
      ) : null}
    </CrmDrawer>
  );
}

export default CrmRecordPreview;
